import { createRouter, createWebHistory } from "vue-router";
import Login from "../views/LoginUser.vue";
import RegisterUser from "../views/RegisterView.vue";
import HomeTable from "../views/TableView.vue";
import RecoverPassword from "../components/ForgotPassword.vue";
import Dashboard from "../components/KPIsChart.vue";

const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/register",
    name: "RegisterUser",
    component: RegisterUser,
  },
  {
    path: "/home-table",
    name: "HomeTable",
    component: HomeTable,
  },
  {
    path: "/recover-password",
    name: "RecoverPassword",
    component: RecoverPassword,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "Look Up Tool";
  next();
});


export default router;
